<template>
  <div
    :class="['button-component', { active, 'px-3': !small, 'px-2': small }]"
    @click="$emit('click', $event)"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    active: Boolean,
    small: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
.button-component {
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: var(--contrast);
  user-select: none;
  transition: background-color 0.2s;
  border-radius: 4px;
  &:hover {
    background-color: var(--contrast-accentuate);
  }

  &.active {
    color: var(--primary);
  }
}
</style>
